export const BASE_URL = `https://live.alliancecredit.ca`;
export const FILE_URL = `https://v2.portail.alliancecredit.ca/files`;
